import { motion } from "framer-motion";
import splitStringUsingRegex from "../utils/splitStringUsingRegex";
import "../css/Home.css";

const text = "Welcome to Gloucester Road Pharmacy, your neighbourhood pharmacy situated on Gloucester Road in Bristol known for its independent shops.";

const charVariants = {
  hidden: { opacity: 0 },
  reveal: { opacity: 1 },
};

const Home = () => {
  const textChars = splitStringUsingRegex(text);

  return (
    <div className="home">
      <div className="home__content">
        <div className="home__image-container">
          <img 
            src="/pharmacy.jpg" 
            alt="Gloucester Road Pharmacy" 
            className="home__image"
          />
        </div>
        <motion.p
          initial="hidden"
          whileInView="reveal"
          transition={{ staggerChildren: 0.02 }}
        >
          {textChars.map((char, index) => (
            <motion.span
              key={index}
              transition={{ duration: 0.5 }}
              variants={charVariants}
            >
              {char}
            </motion.span>
          ))}
        </motion.p>
      </div>
    </div>
  );
};

export default Home;